import { FASTElement } from "@microsoft/fast-element";
/**
 * CardHeader
 * @summary A component for card headers, supporting a flexible slot-based layout for customization.
 *
 * @example
 * ```html
 * <fabric-card-header>
 *   <div slot="start">Logo</div>
 *   <img slot="image" src="path/to/image.jpg" alt="Header Image">
 *   <h1 slot="header">Main Title</h1>
 *   <span slot="subtitle">Subtitle Text</span>
 *   <fabric-button slot="action">Action Button</fabric-button>
 *   <div slot="end">Additional Info</div>
 * </fabric-card-header>
 * ```
 *
 * @slot start - Slot for content positioned at the start of the header.
 * @slot image - Slot for an image within the header.
 * @slot header - Slot for the main header content.
 * @slot subtitle - Slot for the subtitle text.
 * @slot action - Slot for action elements, typically buttons or links.
 * @slot end - Slot for content positioned at the end of the header.
 * @slot default - Default slot for card header content.
 *
 * @csspart image - The image container within the header.
 * @csspart header - The main header container.
 * @csspart row - A row within the header for layout.
 *
 * @extends FASTElement
 * @tagname fabric-card-header
 * @public
 */
export class CardHeader extends FASTElement {
}
//# sourceMappingURL=card-header.js.map